import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b396a0b0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "IntroGalleryConfirmation__overlay"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "IntroGalleryConfirmation__container--transparent"
};
var _hoisted_3 = {
  key: 0,
  "class": "IntroGalleryConfirmation__container"
};
var _hoisted_4 = {
  "class": "IntroGalleryConfirmation__text"
};
var _hoisted_5 = {
  key: 1,
  "class": "IntroGalleryConfirmation__container"
};
var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"IntroGalleryConfirmation__text\" data-v-b396a0b0><div class=\"IntroGalleryConfirmation__text--larger\" data-v-b396a0b0>NOTICE: This specific Avitar does not currently support <b data-v-b396a0b0><i data-v-b396a0b0>full animations</i></b></div><div class=\"IntroGalleryConfirmation__text--gapped\" data-v-b396a0b0>However! Their voices will work and you can</div><div data-v-b396a0b0>still have fluid conversations with them like you&#39;re talking to a real person.</div><div class=\"IntroGalleryConfirmation__text--gapped\" data-v-b396a0b0>They also support image requests where they can send you images!</div><div class=\"IntroGalleryConfirmation__text--gapped\" data-v-b396a0b0>These AIVitars will eventually be fully animated</div><div data-v-b396a0b0>but we&#39;ll prioritize their development by usage and requests from users like you that we receive</div><div data-v-b396a0b0>in our discord server so please <a href=\"https://discord.gg/PSDC7espu7\" data-v-b396a0b0>join the conversation.</a></div><div class=\"IntroGalleryConfirmation__lower\" style=\"margin-bottom:20px;margin-top:20px;width:100%;\" data-v-b396a0b0>To use a fully animated AIVitar, look towards the top of the gallery. We will always stick the fully animated AIVitars towards the top.</div></div>", 1);
var _hoisted_7 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "padding": "10px",
    "gap": "15px",
    "height": "70px"
  }
};
var _hoisted_8 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_9 = {
  style: {
    "flex": "1"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [false ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" X-Rated Conversations Supported Today but Images Coming Soon! "), _createElementVNode("button", {
    "class": "button button--selected",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateIntroIntroGalleryConfirmation', false);
    })
  }, "Close Window")])])) : _createCommentVNode("", true), true ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$store.commit('updateShowGalleryConfirmation', false);
    }),
    "class": "button button--secondary",
    style: {
      "padding-top": "0px"
    }
  }, "Nevermind")]), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.keepGoing();
    }),
    "class": _normalizeClass({
      button: true,
      'button--disabled': false
    }),
    style: {
      "padding-top": "0px"
    }
  }, "I Understand")])])])) : _createCommentVNode("", true)])]);
}